{
  "title": "Settings",
  "subtitle": "Account and notification preferences.",
  "profile": {
    "title": "Profile",
    "description": "Your name is what teammates see on tasks, comments and mentions.",
    "name_label": "Name",
    "name_placeholder": "Your full name",
    "email_label": "Email",
    "email_hint": "Your email is the identity you sign in with and can't be changed here.",
    "errors": {
      "name_invalid": "Invalid name.",
      "generic": "Couldn't save."
    }
  },
  "workspace": {
    "title": "Workspace",
    "description": "The name your workspace shows in the sidebar and in invitations.",
    "name_label": "Workspace name",
    "owner_only_hint": "Only the workspace owner can change the name.",
    "errors": {
      "name_invalid": "Invalid name.",
      "not_owner": "Only the owner can change the name.",
      "generic": "Couldn't save."
    }
  },
  "notifications": {
    "title": "Email notifications",
    "description": "Pick which emails you want to receive.",
    "loading": "Loading preferences...",
    "plan_gate": {
      "title": "Your current plan doesn't include email notifications",
      "description": "Your preferences are saved, but emails are only sent on Pro plans or higher.",
      "cta": "View plans →"
    },
    "kinds": {
      "task_assigned": {
        "title": "You're assigned a task",
        "description": "Get an email when someone assigns you a new task."
      },
      "task_completed": {
        "title": "A task you created is completed",
        "description": "Get an email when someone completes a task you created."
      },
      "comment_posted": {
        "title": "Someone comments on your tasks",
        "description": "Alerts when someone adds a comment to a task you own or created."
      },
      "user_mentioned": {
        "title": "You're mentioned",
        "description": "When someone {'@'}-mentions you in a comment."
      }
    },
    "errors": {
      "load_failed": "Couldn't load your preferences.",
      "save_failed": "Couldn't save."
    }
  },
  "security": {
    "title": "Security",
    "description": "Change your password.",
    "current_password_label": "Current password",
    "new_password_label": "New password",
    "new_password_hint": "Minimum 8 characters.",
    "confirm_password_label": "Confirm new password",
    "show_password": "Show password",
    "hide_password": "Hide password",
    "submit": "Change password",
    "saved": "Updated ✓",
    "errors": {
      "current_mismatch": "The current password doesn't match.",
      "rate_limit": "Too many attempts. Wait a moment and try again.",
      "generic": "Couldn't change the password."
    }
  },
  "language": {
    "title": "Language",
    "description": "Pick the interface language."
  },
  "apps": {
    "title": "Mobile apps",
    "description": "Take Tworks on your phone with the same account.",
    "ios_hint": "On iPhone and iPad, install the web app from Safari: Share → Add to Home Screen. The native iOS app is on its way."
  },
  "api": {
    "title": "API",
    "description": "Generate API keys for external integrations. See the documentation at /docs/api.",
    "docs_link": "View documentation",
    "empty": "You don't have any API keys yet.",
    "generate": "Generate key",
    "scopes_label": "Permissions",
    "scope_read": "Read tasks",
    "scope_write": "Create tasks",
    "last_used": "Last used",
    "never_used": "Never used",
    "revoke": "Revoke",
    "revoke_confirm": "Revoke this key? Integrations using it will stop working.",
    "modal": {
      "title": "New API key",
      "name_label": "Name",
      "name_placeholder": "e.g. Zapier integration",
      "create": "Create key",
      "cancel": "Cancel",
      "secret_title": "Copy your key now",
      "secret_warning": "You won't be able to see it again. Store it somewhere safe.",
      "copy": "Copy",
      "copied": "Copied!",
      "done": "Done",
      "name_required": "Name is required.",
      "scope_required": "Select at least one permission."
    }
  },
  "danger": {
    "title": "Danger zone",
    "description": "Deleting your account is permanent. Your tasks, projects, attachments, and recorded meetings will be erased.",
    "delete_button": "Delete my account",
    "confirm_title": "Delete your account?",
    "confirm_body": "Type {word} to confirm. This can't be undone.",
    "confirm_word": "delete",
    "confirm_placeholder": "delete",
    "error": "We couldn't delete the account. Try again."
  },
  "public_directory": {
    "title": "Public requests page",
    "description": "Generate a public link for your workspace where anyone picks the team and board to send their request to. This centralizes tickets.",
    "enable_label": "Enable the team's public page",
    "link_label": "Workspace public link",
    "copy": "Copy",
    "copied": "Copied!",
    "regenerate": "Regenerate link",
    "hint": "Shows your teams and their boards with requests enabled."
  }
}
